import { liveQuoteTradeApiConnector } from 'apiConnector/secondary-market/live/trade';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { liveTradeActions } from 'state/secondaryMarket/live/trade/trade.action';
import type { EpicWithThunk } from 'state/state.common';
import { workspaceTabSetBusy } from 'state/workspaces/workspace.actions';
import type { HttpError } from 'utils/http/httpClient.model';
import { extractHttpErrorMessage } from 'utils/http/httpClient.model';

import { isRejection } from './liveQuoteRequestEpic';

export function liveTradeRequestEpic(): EpicWithThunk {
  return (action$, _state$, { httpClient, getNow }) => {
    const { requestTrade } = liveQuoteTradeApiConnector(httpClient);
    return action$.pipe(
      ofType('SECONDARY_MARKET_LIVE_TRADE_REQUESTED'),
      mergeMap(({ request, tabId, workspaceType }) => {
        return requestTrade(request).pipe(
          mergeMap(data =>
            of(
              liveTradeActions.secondaryMarketTradeReceived(tabId, data, getNow()),
              workspaceTabSetBusy(tabId, workspaceType, false),
            ),
          ),
          catchError((error: HttpError) => {
            const message = extractHttpErrorMessage(error, { backend: 'domino' });
            if (isRejection(error) && message !== undefined) {
              return of(
                liveTradeActions.secondaryMarketTradeRejected(tabId, message),
                workspaceTabSetBusy(tabId, workspaceType, false),
              );
            }
            return of(
              liveTradeActions.secondaryMarketTradeFailed(tabId, message as string),
              workspaceTabSetBusy(tabId, workspaceType, false),
            );
          }),
        );
      }),
    );
  };
}
